<template>
  <div class="list">
    <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
      :loading-text="$t('Hint.loading')" immediate-check>
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap">
          <div class="item_wrap_head">
            <div class="head_left">
              <div class="head_left_title">{{ item.side == 'buy' ? $t('买入余额') : $t('卖出余额') }}</div>
              <div class="head_left_desc">{{ item.maker_username }}</div>
            </div>
            <div class="head_status">{{ getStatus(item.status) }}</div>
          </div>
          <div class="item_wrap_moneys">
            <div class="money_item">
              <div class="money_title">{{ $t('可交易') }}</div>
              <div class="money_val">{{ $money(item.available_amount || '0.00') }}</div>
            </div>
            <div class="money_item">
              <div class="money_title">{{ $t('挂单总额') }}</div>
              <div class="money_val">{{ $money(item.amount || '0.00') }}</div>
            </div>
          </div>
          <p v-if="item.remark">{{ item.remark }}</p>
          <div class="item_wrap_btn" v-if="item.userid == userInfo.id">{{ $t('自己的挂单') }}</div>
          <div class="item_wrap_btn btn" @click="tradeChange(item)" v-else>{{ item.side == 'sell' ? $t('买入余额') :
            $t('卖出余额') }}</div>
        </div>
      </template>
      <div class="list_not" v-else>
        <img :src="require('@/assets/Img/null/null.png')" alt="">
        <span>{{ $t('无C2C挂单') }}</span>
      </div>
    </List>
    <van-popup v-model="popShow" position="bottom" round>
      <div class="pop">
        <h2>{{ popItem.side == 'sell' ? $t('买入余额') : $t('卖出余额') }}</h2>
        <p>{{ popItem.maker_username }} · {{ $money(popItem.amount || '0.00') }}</p>
        <div class="c2c_preview">
          <span>{{ $t('可交易') }}</span>
          <div>{{ $money(popItem.available_amount || '0.00') }}</div>
        </div>
        <div class="c2c_field">
          <span>{{ $t('交易金额') }}(INR)</span>
          <van-field v-model="popItem.available_amount" readonly />
        </div>
        <div class="c2c_field">
          <span>{{ $t('交易密码') }}</span>
          <van-field v-model="paypass" :placeholder="$t('请输入交易密码')" />
        </div>
        <template v-if="popItem.side == 'sell'">
          <div class="c2c_field">
            <span>{{ $t('手续费') }}</span>
            <van-field v-model="popItem.fee_amount" readonly />
          </div>
          <div class="c2c_preview">
            <span>{{ $t('实际到账') }}</span>
            <div>{{ $money(popItem.available_amount - popItem.fee_amount) }}</div>
          </div>
        </template>
        <div class="btns">
          <div class="btn" @click="popShow = false">{{ $t('My.Button.One') }}</div>
          <div class="btn confirm" @click="popSubmit">{{ $t('My.Button.Two') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { List, Popup, Field, Toast } from "vant";
import { post } from "@/utils/newRequest";
import { mapGetters } from "vuex";
import { C2C_ORDER_TAKE } from "@/api";
export default {
  components: {
    List,
    [Popup.name]: Popup,
    [Field.name]: Field
  },
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
      popShow: false,
      popItem: {},
      paypass: '',
      loadingRequest: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    getStatus(_status) {
      switch (_status) {
        case 'open':
          return this.$t('已启用')
          break;
        case 'locked':
          return this.$t('锁定')
          break;
        case 'finished':
          return this.$t('完成')
          break;
        case 'cancelled':
          return this.$t('停用')
          break;
        case 'expired':
          return this.$t('过期')
          break;
        default:
          break;
      }
    },
    tradeChange(_item) {
      this.popItem = _item;
      this.popShow = true;
    },
    async popSubmit() {
      if (this.userInfo.setpaypass != 1) return Toast(this.$t('请设置交易密码'));
      if (!this.paypass) return Toast(this.$t('请输入交易密码'));
      Toast.loading();
      try {
        const res = await C2C_ORDER_TAKE({
          id: this.popItem.id,
          paypass: this.paypass
        })
        Toast.clear();
        Toast(res.msg);
        setTimeout(() => {
          this.popShow = false;
          this.popItem = {};
          this.page = 0
          this.getList(true);
          this.$store.dispatch('getuserInfo')
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg)
      }
    },
    async getList(lower = false) {
      if (this.loadingRequest) return;
      this.loadingRequest = true;
      if (!lower) {
        this.page++;
      }
      this.loading = true;
      try {
        const { lists, hasMorePages, total: _total } = await post("/c2c/market", {
          pagesize: 20,
          page: this.page,
        });
        const realList = lists;
        this.hasMore = hasMorePages;
        if (lower) {
          this.list = [...realList]
        } else {
          this.list = [...this.list, ...realList];
        }
        this.loading = false;
        this.loadingRequest = false;
      } catch (error) {
        if (!lower) this.page--;
        this.loading = false;
        this.loadingRequest = false;
      }
    },
  }
}

</script>

<style lang="less" scoped>
:deep(.van-list) {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item_wrap {
  padding: 12px;
  border: 1px solid rgba(15, 23, 42, .06);
  border-radius: 14px;
  background: #fff;

  .item_wrap_head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;

    .head_left {

      .head_left_title {
        line-height: 1;
        color: #111827;
        font-size: 15px;
        font-weight: 900;
      }

      .head_left_desc {
        margin-top: 3px;
        color: #7a8597;
        font-size: 12px;
        font-weight: 800;
      }
    }

    .head_status {
      background: #31e2a524;
      color: #31e2a5;
      flex-shrink: 0;
      padding: 4px 8px;
      border-radius: 999px;
      font-size: 12px;
      font-style: normal;
      font-weight: 900;
    }
  }

  .item_wrap_moneys {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    gap: 8px;
    margin-top: 10px;

    .money_item {
      padding: 9px 10px;
      border-radius: 12px;
      background: #f7f9fc;

      .money_title {
        color: #7a8597;
        font-size: 11px;
        font-weight: 800;
      }

      .money_val {
        margin-top: 4px;
        overflow: hidden;
        color: #111827;
        font-size: 12px;
        font-weight: 900;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  p {
    margin: 9px 0 0;
    padding: 8px 10px;
    border-radius: 12px;
    background: #ffb24d1f;
    color: #9a5d00;
    font-size: 12px;
    font-weight: 800;
  }

  .item_wrap_btn {
    height: 32px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #a6b5af;
    color: #0f172a;
    box-shadow: 0 9px 20px #31e2a547;
    border-radius: 999px;
  }

  .btn {
    background: linear-gradient(90deg, #8ff5d1, #31e2a5);
  }
}

.list_not {
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 160px;
    height: 160px;
    display: block;
  }

  span {
    padding: 16px 0;
    color: #0f172a;
    font-size: 14px;
  }
}

.pop {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 16px 30px;
  background: #f7f9fc;

  h2 {
    margin: 0;
    color: #111827;
    font-size: 20px;
    font-weight: 900;
  }

  p {
    margin: 6px 0 0;
    color: #697386;
    font-size: 13px;
    line-height: 1.5;
  }

  .c2c_preview {
    padding: 9px 10px;
    border-radius: 12px;
    background: #f7f9fc;

    span {
      color: #7a8597;
      font-size: 11px;
      font-weight: 800;
    }

    div {
      margin-top: 4px;
      overflow: hidden;
      color: #111827;
      font-size: 12px;
      font-weight: 900;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .c2c_field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    span {
      color: #566071;
      font-size: 12px;
      font-weight: 600;
    }

    :deep(.van-field) {
      line-height: 42px;
      height: 42px;
      padding: 0 12px;
      border: 1px solid rgba(15, 23, 42, .08);
      border-radius: 12px;
      background: #fff;
      color: #111827;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .btns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    .btn {
      height: 44px;
      border-radius: 1000px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      font-size: 14px;
      background: #fff;
      color: #323233;
      border: 1px solid #dcdee0;
    }

    .confirm {
      background: linear-gradient(90deg, #8ff5d1, #31e2a5);
      border-color: transparent;
      color: #064b38;
      font-weight: 800;
      box-shadow: 0 9px 20px #31e2a547;
    }
  }
}
</style>